"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = void 0;

var _react = _interopRequireDefault(require("react"));

var _view = require("../view");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Spacer = function Spacer(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1 : _ref$size,
      extend = _ref.extend;
  return /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: [function (_ref2) {
      var layout = _ref2.theme.layout;
      return {
        width: size * layout.grid,
        height: size * layout.grid
      };
    }, extend]
  });
};

exports.Spacer = Spacer;